<template>
  <button type="button"
          class="genre-button"
          @click="setGenreToStore(genre)"
  >
    {{ genreName }}
  </button>
</template>

<script>
export default {
  name: "GenreButton",
  props: {
    genre: {
      type: Object,
      required: true
    }
  },

  computed: {
    genreName() {
      return this.genre.name;
    }
  },

  methods: {
    setGenreToStore(genre) {
      if (this.$route.name === 'discover-genres' && this.$store.getters.getSelectedGenres.map(e => e.name).includes(genre.name)) return;
      const isGenreSubject = tag => tag.name.toLowerCase().startsWith('subject') ? 'subjects' : 'genres';
      const selectedGenres = new Array(genre);
      this.$store.commit('setGenres', selectedGenres);
      this.$router.push({name: 'discover-genres', query: {q: isGenreSubject(genre.tag), tag: genre.name}});
      // this.$router.push({name: 'discover-genres', query: {q: isGenreSubject(genre.tag)}}).then(() => {}).catch(() => {});
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/sass/abstracts/_variables.scss';

button.genre-button {
  @include font-10-md;
  color: $c_black;
  padding: 4px 10px;
  border-radius: 5px;
  border: 1px solid $c_border_grey !important;
  text-transform: uppercase;
  display: inline-block;
  vertical-align: middle;
  transition: all 0.2s ease;
  background-color: transparent;

  &:hover {
    background-color: $c_black;
    color: $c_white !important;
    border: 1px solid $c_black;
  }
}
</style>
